import PropTypes from 'prop-types';

const displayName = 'ErrorBottomSheet';
const propTypes = {
  visible: PropTypes.bool,
  btn: PropTypes.oneOfType([
    PropTypes.shape({
      text: PropTypes.string,
      onClick: PropTypes.func,
    }),
    PropTypes.shape({
      positive: PropTypes.shape({
        text: PropTypes.string,
        onClick: PropTypes.func,
      }),
      negative: PropTypes.shape({
        text: PropTypes.string,
        onClick: PropTypes.func,
      }),
    }),
  ]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.shape({
    img: PropTypes.string.isRequired,
    title: PropTypes.string,
    desc: PropTypes.string,
  }),
  intl: PropTypes.object.isRequired,
  disableSwipe: PropTypes.bool,
};
const defaultProps = {
  visible: false,
  btn: {
    text: '',
    onClick: () => {},
  },
  swipeableViewsProps: {},
};

export default { displayName, propTypes, defaultProps };
